import MomentUtils from '@date-io/moment';
import moment from 'moment';
import {
  KeyboardDatePicker,
  KeyboardDatePickerProps,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import React from 'react';
import {DEFAULT_DATE_FORMAT} from '@shared/utils/DateTimeUtils';
import {TextFieldProps} from '@material-ui/core/TextField';
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import {GET_8_PIXEL_BOX} from '../../../style/variable';
import DateIcon from '@components/system/MyIcons/DateIcon';
import {IconButton} from '@material-ui/core';
import {Clear} from '@material-ui/icons';

const useStyle = makeStyles(() =>
  createStyles({
    datePickerWrapperFormClass: {
      paddingBottom: `${GET_8_PIXEL_BOX(0)}`,
      marginBottom: '0',
      padding: '0px',
      display: 'contents'
    },
    root: {
      '& .MuiIconButton-root': {
        padding: '4px'
      }
    },
    additionalStylesForYear: {
      '& .MuiIconButton-root': {
        padding: '4px',
        marginRight: '10px'
      }
    },
    iconButton: {
      position: 'absolute',
      left: '247px',
      height: '15px',
      width: '15px',
      margin: '0.3rem 0 0 0'
    },
    groupLevelIconButton: {
      width: '15px',
      height: '15px',
      margin: '0.3rem 0 0 0',
      position: 'absolute',
      transform: 'translate(-100%, 2%)'
    }
  })
);

export interface DateTimePickerWrapperProps extends KeyboardDatePickerProps {
  className?: string;
  inputClassName?: string;
  id?: string;
  placeHolder?: string;
  /** Use null for empty; undefined breaks Rifm inside KeyboardDatePicker. */
  value: string | Date | null | undefined;
  onBlur?: TextFieldProps['onBlur'];
  onChange(date: MaterialUiPickersDate, value?: string | null): void;
  filterByYear?: boolean;
  systemLevel?: boolean;
}

const DateTimePickerWrapper = (
  props: DateTimePickerWrapperProps
): React.ReactElement => {
  const {
    className,
    inputClassName,
    placeHolder,
    id,
    value,
    onChange,
    onBlur,
    filterByYear,
    systemLevel,
    inputVariant = 'outlined',
    ...rest
  } = props;
  const classes = useStyle();
  const handleClear = () => {
    onChange(null, null);
  };
  const normalizedValue = value === undefined || value === '' ? null : value;
  return (
    <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
      {/* <div> */}
      <KeyboardDatePicker
        autoOk
        variant="inline"
        className={
          filterByYear
            ? [
                classes.datePickerWrapperFormClass,
                classes.root,
                classes.additionalStylesForYear,
                className
              ].join(' ')
            : [
                classes.datePickerWrapperFormClass,
                classes.root,
                className
              ].join(' ')
        }
        inputProps={{
          className: [inputClassName].join(' ')
        }}
        format={DEFAULT_DATE_FORMAT}
        views={filterByYear ? ['year'] : ['year', 'month', 'date']}
        inputVariant={inputVariant}
        margin={'dense'}
        orientation={'portrait'}
        PopoverProps={{
          anchorOrigin: {horizontal: 'left', vertical: 'bottom'},
          transformOrigin: {horizontal: 'left', vertical: 'top'}
        }}
        keyboardIcon={<DateIcon />}
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        invalidDateMessage={''}
        id={id}
        placeholder={placeHolder}
        value={normalizedValue}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
        maxDateMessage={''}
        minDateMessage={''}
      />
      {filterByYear && (
        <IconButton
          className={
            systemLevel ? classes.iconButton : classes.groupLevelIconButton
          }
          onClick={handleClear}
          aria-label="clear date">
          <Clear />
        </IconButton>
      )}
      {/* </div> */}
    </MuiPickersUtilsProvider>
  );
};

export default DateTimePickerWrapper;
